import { Role } from './roles';

// ============================================================================
// Declarative capability -> allowed-roles map.
// A capability is granted when the user holds at least one of its roles.
// ============================================================================

const { ADMIN, PROFESSOR } = Role;

export const capabilities = {
  // Shared staff capabilities (admin + professor)
  viewAnalytics: [ADMIN, PROFESSOR],
  viewAttendance: [ADMIN, PROFESSOR],
  viewCourses: [ADMIN, PROFESSOR],
  viewBanners: [ADMIN, PROFESSOR],
  viewForum: [ADMIN, PROFESSOR],
  viewBookClubs: [ADMIN, PROFESSOR],
  // `manage`, não `view`: a tela de presença escreve — marca e desmarca.
  manageBookClubAttendance: [ADMIN, PROFESSOR],
  // Admin-only capabilities
  viewSales: [ADMIN],
  viewCoupons: [ADMIN],
  manageProfessors: [ADMIN],
  manageCategories: [ADMIN],
  viewUsers: [ADMIN],
  manageUserRoles: [ADMIN],
  manageCourseInstructors: [ADMIN],
  manageApiClients: [ADMIN],
} as const satisfies Record<string, readonly Role[]>;

export type Capability = keyof typeof capabilities;
